import { withWhiteSwatch } from "./swatchPalette";

// Preset solid colours for the theme colour pickers (Gallery Theme, LinkVault,
// Business Box). withWhiteSwatch puts #FFFFFF first (Gordon law 2026-09-16).
export const colors = withWhiteSwatch([
  "#F32A00",
  "#F79A00",
  "#86BB00",
  "#29C18C",
  "#F5CC3B",
  "#123051",
  "#77CCCD",
  "#AAABAD",
  "#E25297",
  "#99439D",
  "#C9C4B4",
  "#F79781",
  "#F8CD80",
  "#C4DD81",
  "#94DAC1",
  "#FFEDAE",
  "#8BA6C2",
  "#BBE6E7",
  "#D6D7D8",
  "#E9ADCA",
  "#CCA3CF",
  "#F0EADB",
]);

export const gradients = [
  "linear-gradient(45deg, #F7FED5, #CCFEFF, #FDCFFE, #F5EEDE)",
  "linear-gradient(90deg, #C04848 0%, #480048 100%)",
  "linear-gradient(90deg, #232526 0%, #414345 100%)",
  "linear-gradient(90deg, #536976 0%, #292E49 100%)",
  "linear-gradient(90deg, #948E99 0%, #2E1437 100%)",
  "linear-gradient(90deg, #360033 0%, #0B8793 100%)",
  "linear-gradient(90deg, #F7941E 0%, #004E8F 100%)",
  "linear-gradient(90deg, #5C258D 0%, #4389A2 100%)",
  "linear-gradient(90deg, #29323C 0%, #485563 100%)",
  "linear-gradient(90deg, #7B7E86 0%, #9A9EA5 100%)",
  "linear-gradient(90deg, #E52D27 0%, #B31217 100)",
  "linear-gradient(90deg, #9400D3 0%, #4B0082 100%)",
  "linear-gradient(90deg, #FF00CC 0%, #333399 100%)",
  "linear-gradient(90deg, #0576BE 0%, #1C1EA3 100%)",
  "linear-gradient(90deg, #0083FE 0%, #00FFF0 100%)",
  "linear-gradient(90deg, #093028 0%, #237A57 100%)",
  "linear-gradient(90deg, #28C22E 0%, #197225 100%)",
  "linear-gradient(90deg, #73E49A 0%, #1BA049 98.96%)",
  "linear-gradient(90deg, #FFC500 0%, #C21500 100%)",
  "linear-gradient(90deg, #EEF21B 0%, #FFC412 100%)",
  "linear-gradient(90deg, #FFEFEF 0%, #FF7C7C 100%)",
  "linear-gradient(90deg, #D4BBFF 0%, #BE95FF 98.96%)",
  "linear-gradient(90deg, #F4C4F3 0%, #FC67FA 100%)",
  "linear-gradient(90deg, #0062FF 0%, #6FA3FF 100%)",
  "linear-gradient(90deg, #2980B9 0%, #6DD5FA 50%, #FFFFFF 100%)",
  "linear-gradient(90deg, #64965E 0%, #81FF8A 100%)",
  "linear-gradient(90deg, #D4FC79 0%, #96E6A1 100%)",
  "linear-gradient(90deg, #F8B500 0%, #FCEABB 100%)",
  "linear-gradient(90deg, #FEFDD1 0%, #FFFC00 97.4%)",
  "linear-gradient(90deg, #FFF1B0 0%, #FFC994 100%)",
  "linear-gradient(90deg, #9FD2BA 0%, #CD70B9 100%)",
  "linear-gradient(90deg, #E0EAFC 0%, #CFDEF3 100%)",
  "linear-gradient(90deg, #E1F5C4 0%, #EDE574 100%)",
  "linear-gradient(90deg, #C6FFDD 0%, #FBD786 50%, #F7797D 100%)",
  "linear-gradient(90deg, #757F9A 0%, #D7DDE8 100%)",
  "linear-gradient(90deg, #70E1F5 0%, #FFD194 100%)",
  "linear-gradient(90deg, #BFE9FF 0%, #FF6E7F 100%)",
  "linear-gradient(90deg, #FFFFFF 0%, #FFEFBA 100%)",
  "linear-gradient(90deg, #F1F2B5 0%, #91F2FF 100%)",
];
